module.exports = __webpack_public_path__ + "static/img/upload_a_medical_record_by_doctor.84703f0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/upload_a_medical_record_by_doctor.jpg
// module id = B/1Z
// module chunks = 7